var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      ref: "signupForm",
      attrs: { id: "signup_form", method: "post" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.submit.apply(null, arguments)
        },
      },
    },
    [
      _vm._t("default"),
      _vm._v(" "),
      _c("input", {
        attrs: { type: "hidden", name: "userInfo", id: "userInfo" },
        domProps: { value: _vm.strUserInfoJson },
      }),
      _vm._v(" "),
      _c("input", {
        attrs: { type: "hidden", name: "loginId", id: "loginId" },
        domProps: { value: _vm.loginId },
      }),
      _vm._v(" "),
      _c("input", {
        attrs: { type: "hidden", name: "username", id: "mkdb_id" },
        domProps: { value: _vm.userinfo.mkdb_id },
      }),
      _vm._v(" "),
      _c("input", {
        attrs: { type: "hidden", name: "jl_otp_id", id: "jl_otp_id" },
        domProps: { value: _vm.userinfo.jl_otp_id },
      }),
      _vm._v(" "),
      _vm.siwaErrorNoEmail
        ? _c("div", { staticClass: "errorContainer" }, [_vm._m(0)])
        : _vm.isApple
        ? _c("div", { staticClass: "jleague_loader" })
        : _vm._e(),
      _vm._v(" "),
      !_vm.isApple
        ? _c("user-info-form", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.isBasicInfo,
                expression: "isBasicInfo",
              },
            ],
            attrs: {
              "flp-token": _vm.flpToken,
              step: _vm.step,
              userinfo: _vm.userinfo,
              "display-pattern": _vm.displayPattern,
              "is-display-agreement-check": _vm.isDisplayAgreementCheck,
              "is-email-field": _vm.isEmailField,
              "is-xhr": _vm.isXhr,
              "is-duplicate-jleague-id": _vm.isDuplicateJleagueId,
              "editable-jleague-id": _vm.editableJleagueId,
              "is-email-token": _vm.isEmailToken,
              "form-name": "signup",
            },
            on: { next: _vm.next, "set-password": _vm.setPassword },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isFavoriteClub
        ? _c("favorite-club", {
            attrs: {
              step: _vm.step,
              userinfo: _vm.userinfo,
              "is-xhr": _vm.isXhr,
              "check-receive-mail": _vm.checkReceiveMail,
            },
            on: {
              next: _vm.next,
              back: _vm.back,
              watch: _vm.watchCheckReceiveMail,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isFavoritePlayer
        ? _c("favorite-player", {
            attrs: {
              step: _vm.step,
              userinfo: _vm.userinfo,
              "is-xhr": _vm.isXhr,
            },
            on: { next: _vm.next, back: _vm.back },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isConfirm
        ? _c(
            "user-info-confirm",
            {
              ref: "confirm",
              attrs: {
                step: _vm.step,
                userinfo: _vm.userinfo,
                "display-pattern": _vm.displayPattern,
                "is-email-field": _vm.isEmailField,
                "is-xhr": _vm.isXhr,
                "is-recaptcha-invalid": _vm.isRecaptchaInvalid,
                "is-apple": _vm.isApple,
                "form-name": "signup",
              },
              on: { back: _vm.back },
            },
            [
              _c("template", { slot: "recaptchaUserInfo" }, [
                _c("img", {
                  attrs: {
                    src: "data:image/gif;base64,R0lGODdhAQABAPAAAAAAAAAAACwAAAAAAQABAAACAkQBADs=",
                    width: "0",
                    height: "0",
                    alt: "",
                  },
                  on: {
                    load: function ($event) {
                      return _vm.renderRecaptcha()
                    },
                    error: function ($event) {
                      return _vm.renderRecaptcha()
                    },
                  },
                }),
                _vm._v(" "),
                _vm.recaptchaSitekey
                  ? _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "justify-content": "center",
                        },
                      },
                      [
                        _c("div", {
                          staticClass: "g-recaptcha",
                          attrs: {
                            id: "recaptcha-signup",
                            "data-sitekey": _vm.recaptchaSitekey,
                          },
                        }),
                      ]
                    )
                  : _vm._e(),
              ]),
            ],
            2
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "msg" }, [
      _c("em", { staticClass: "errNote" }, [
        _vm._v("Eメールアドレスを取得できませんでした。"),
        _c("br"),
        _vm._v(" "),
        _c("a", { attrs: { href: "https://appleid.apple.com/" } }, [
          _vm._v("appleid.apple.com"),
        ]),
        _vm._v("にサインインし、「Apple IDを使用中のApp」から"),
        _c("br"),
        _vm._v(
          "\n                「J League ID Login」を削除して再度お試し下さい。"
        ),
        _c("br"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }